import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchTours } from "../../api/toursApi"; // Assuming the API function is here
import toast from "react-hot-toast";

// Async thunk for fetching tours
export const fetchToursThunk = createAsyncThunk(
  "tours/fetchTours",
  async ({ date, logout }, { rejectWithValue }) => {
    try {
      const response = await fetchTours({ date });

      if (!response.data.status) {
        toast.error("Your session has expired");
        setTimeout(() => {
          window.location.replace("/");
          logout();
        }, 1500); // 1.5 seconds delay
        throw new Error(response.data.message);
      }

      return response?.data; // Assuming the data is in the `data` field
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Initial state
const initialState = {
  tours: [],
  loading: false,
  error: null,
};

// Slice
const toursSlice = createSlice({
  name: "tours",
  initialState,
  reducers: {
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchToursThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchToursThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.tours = action.payload;
      })
      .addCase(fetchToursThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { clearError } = toursSlice.actions;
export default toursSlice.reducer;
